import { render } from "./ContactEdit.vue?vue&type=template&id=811f1004"
import script from "./ContactEdit.vue?vue&type=script&lang=js"
export * from "./ContactEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__